export default __webpack_public_path__ + "static/media/riv_logo.7f85002d.svg";